import api from '@/api';

const { $pricing, $core } = api;
// const { $academic } = api;      // :TODO - Fix zonas, borrar linea al subir los cambios

export const { $zones } = $pricing;
// export const { $ceos } = $academic;      // :TODO - Fix zonas, borrar linea al subir los cambios
export const { $countries, $citiesByState } = $core;
